import React, { PropsWithChildren } from 'react';

const ProfileTabList: React.FC<PropsWithChildren<unknown>> = ({ children }) => (
  <div className="shadow-bottomDivider flex" role="tablist">
    {children}
  </div>
);

export default ProfileTabList;
